import React, {Fragment, useEffect, useState} from "react";

import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import AppNavbar from "../components/common/AppNavbar";
import EvvForm from "../components/evv/EvvForm";
import AppFooter from "../components/common/AppFooter";
import {useAuth} from "../context/AuthProvider";
import EmployeeService from "../services/employee.service";

function HomePage(props) {
    const {user} = useAuth();
    const [userInfo, setUserInfo] = useState(null);
    const fetchData = (dataId) => {
        EmployeeService.getDocById(dataId).then((docSnap) => {
            if (docSnap.exists()) {
                setUserInfo(docSnap.data());
            }
        });
    }
    useEffect(() => {
        if (user){
            fetchData(user.uid);
        }
    }, [user]);
    return (
        <Fragment>
            <AppNavbar/>
            <Container component="main" maxWidth="lg">
                <Box
                    sx={{
                        marginTop: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Typography component="h1" variant="h4" sx={{color: "black"}}>
                        Missed EVV Correction
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        component="div"
                        sx={{color: "gray"}}
                    >
                        Please complete the form below. We request you to submit the correct date and valid reason
                        as we keep the data for verification purpose.
                    </Typography>
                </Box>
                <Divider/>
                <EvvForm applyFor={userInfo}/>
            </Container>
            <AppFooter/>
        </Fragment>
    );
}

export default HomePage;
